import produce from 'immer';
import queryString from 'query-string';

export * from './GetName';

export function getFinalBreadcrumb(array: any, currentPosition: any, folderId: any) {
  let link = '/folder/' + folderId + '?bc=';
  for (var i = 0; i < array.length; i++) {
    link = link + array[i];
    if (i !== array.length - 1) {
      link = link + ',';
    }
  }
  return link;
}

export function getBreadcrumb(array: any, currentPosition: any, folderId: any) {
  let link = '/folder/' + array[currentPosition];
  for (var i = currentPosition - 1; i >= 0; i--) {
    if (i === currentPosition - 1) {
      link = link + '?bc=';
    }
    link = link + array[i];
    if (i !== 0) {
      link = link + ',';
    }
  }
  return link;
}

export function getFolderLink(params: any, nodeId: any, folderId: any) {
  let link = '/folder/' + nodeId + '?';

  const hasMultipleBreadcrumbs = Array.isArray(params.bc);
  const hasOneBreadcrumb = Object.keys(params).length;

  if (hasMultipleBreadcrumbs) {
    const compile = produce(params, (draft: any) => {
      draft['bc'].push(folderId);
    });
    return (link = link + queryString.stringify(compile, { arrayFormat: 'comma' }));
  } else if (hasOneBreadcrumb) {
    return (link = link + 'bc=' + params.bc + ',' + folderId);
  } else {
    return (link = link + 'bc=' + folderId);
  }
}

export function getFolderBackLink(params: any, folderId: any) {
  const hasMultipleBreadcrumbs = typeof params.bc === 'object';
  const hasOneBreadcrumb = typeof params.bc === 'string';

  if (hasMultipleBreadcrumbs) {
    const array: any = params.bc;
    const arrayLength = params.bc!.length;
    return getBreadcrumb(array, arrayLength - 1, folderId);
  } else if (hasOneBreadcrumb) {
    return '/folder/' + params.bc;
  } else {
    return '/search';
  }
}
